import React, { Component } from 'react';
import Editbox from '../../Part_Sample/Editbox';
import Top_Bar from '../../Part_Sample/Top_Bar';

export default class Password extends Component {
	constructor(props) {
		super(props);

		let password = '';
		if (this.props.receiver.active_controller.password != null) password = this.props.receiver.active_controller.password;

		this.state = {
			password: password,
		}
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		this.props.content_handler('System');
	}

	handleChangePassword = (val) => {
		this.setState({ password: val })
	}

	handleRegister = () => {
		this.props.receiver.setPassword({ name: this.props.receiver.active_controller.username, passwd: this.state.password });

	}

	rcvChangePassword = (response) => {
		if (response.result == 'OK') {
			this.handlePrevious();
		} else {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	render() {
		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
		}

		return (
			<div>
				<div style={main_content_style} className='slideInDown'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('passwd')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div style={{ background: 'white', borderRadius: 20, marginTop: 10, marginLeft: 20, padding: 10, width: this.props.width - 60, height: this.props.height - 200 }}>
						<div style={{ display: 'inline-block', width: this.props.width - 240 }}>
							<span>{this.props.receiver.getString('passwd')}</span>
						</div>
						<div>
							<Editbox id='passwd' inputType='password' onChange={(event) => this.handleChangePassword(event.target.value)} value={this.state.password} />
						</div>
					</div>
				</div>
			</div>
		)
	}
}